export default "__VITE_ASSET__nLI1o30m__"